import React, { Fragment, PureComponent } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import "react-datepicker/dist/react-datepicker.css";
import { Table } from 'reactstrap';
import MUIDataTable from "mui-datatables";
import IconButton from '@mui/material/IconButton';
import ConfirmationDialog from "Routes/common/ConfirmationDialog";
 
// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';

import { 
    deleteRangeIronPlay,
    deleteRangeFairway,
    deleteRangeDriver,
    deleteRangeSpeciality,
    getRangeIronPlay,
    getRangeFairway,
    getRangeDriver,
    getRangeSpeciality,
    fetchRangeIronPlay,
    fetchRangeFairway,
    fetchRangeDriver,
    fetchRangeSpeciality,
    fetchPlayerIntervention
 } from 'Actions';

 import AddItem from '../../../../golf/rangeintervention/longgame/component/addform';
 import UpdateItems from '../../../../golf/rangeintervention/longgame/component/editform';
 
class LongItems extends React.Component {
  
    static propTypes = {
        classes: PropTypes.object,
        prev:0,

    };

    UNSAFE_componentWillMount() {
	}
    constructor(props) {
      
        super(props);
        this.confirmationDialog = React.createRef();
        this.state = {  
            student: this.props.data.student,
            startdate:'',
            enddate:'',
            selfrom:0,   
            listdiv:true,
            adddiv:false,
            editdiv:false,
            alllstdiv1:false,
            alllstdiv2:false,
            alllstdiv3:false,
            alllstdiv4:false,
            selfrom:0,
            sellst:0,
            
        };

        this.onPrevSection = this.onPrevSection.bind(this); 
        this.onBacksection = this.onBacksection.bind(this); 
        this.onAddSession = this.onAddSession.bind(this);
        this.onListSession = this.onListSession.bind(this); 
        this.deleteForm = this.deleteForm.bind(this);
        
    }

    onPrevSection(){
        var student=this.state.student;
        var stdate=this.state.startdate;
        var eddate=this.state.enddate;
        this.props.fetchRangeIronPlay(student, stdate, eddate);
        this.props.fetchRangeFairway(student, stdate, eddate);
        this.props.fetchRangeDriver(student, stdate, eddate);
        this.props.fetchRangeSpeciality(student, stdate, eddate);

        this.setState({
            adddiv:false,
            alllstdiv1:false,
            alllstdiv2:false,
            alllstdiv3:false,
            alllstdiv4:false,
            listdiv:true, 
        }); 
    }

    onAddSession(e, id) {
        e.preventDefault();
		this.setState({ 
         selfrom:id,
         listdiv:false,
         adddiv:true,
      });
    }

    onListSession(e, id) {
        e.preventDefault();
        if(id==1){
            var sellst='alllstdiv1';
        }else if(id==2){
            var sellst='alllstdiv2';
        }else if(id==3){
            var sellst='alllstdiv3';
        }else if(id==4){
            var sellst='alllstdiv4';
        }

		this.setState({ 
         sellst:id,   
         [sellst]:true,   
         listdiv:false,
         adddiv:false,
      });
    }

    onBacksection(){
        var student=this.state.student;
        var stdate=this.state.startdate;
        var eddate=this.state.enddate;
        var id=this.state.sellst;
        this.props.fetchRangeIronPlay(student, stdate, eddate);
        this.props.fetchRangeFairway(student, stdate, eddate);
        this.props.fetchRangeDriver(student, stdate, eddate);
        this.props.fetchRangeSpeciality(student, stdate, eddate);

        this.props.fetchPlayerIntervention(student, stdate, eddate);
        if(id==1){
            var sellst='alllstdiv1';
        }else if(id==2){
            var sellst='alllstdiv2';
        }else if(id==3){
            var sellst='alllstdiv3';
        }else if(id==4){
            var sellst='alllstdiv4';
        }

        this.setState({ 
            [sellst]:false,  
            editdiv:false,
            adddiv:false,
            listdiv:true
        });
    }

    editAssessment(gid,selid){
        var student=this.state.student;
        if(selid==1){
            this.props.getRangeIronPlay(gid).then((data) => {   
                var resdata=data.data;
                this.setState({ 
                    eid:resdata[0].griID,
                    seldate:resdata[0].gri_date,
                    selfrom:selid      
                });  
                
                this.setState({ 
                    alllstdiv1:false,               
                    adddiv:false,
                    editdiv:true,   
                  });

            });
        }else if(selid==2){
            this.props.getRangeFairway(gid).then((data) => {   
                var resdata=data.data;
                this.setState({ 
                    eid:resdata[0].griID,
                    seldate:resdata[0].gri_date,
                    selfrom:selid     
                });   
                
                this.setState({ 
                    
                    alllstdiv2:false,               
                    adddiv:false,
                    editdiv:true,   
                  });

            });
            
        }else if(selid==3){
            this.props.getRangeDriver(gid).then((data) => {   
                var resdata=data.data;
                this.setState({ 
                    eid:resdata[0].griID,
                    seldate:resdata[0].gri_date,
                    selfrom:selid     
                });   
                
                this.setState({ 
                    
                    alllstdiv3:false,               
                    adddiv:false,
                    editdiv:true,   
                  });

            });
        }else if(selid==4){
            this.props.getRangeSpeciality(gid).then((data) => {   
                var resdata=data.data;
                this.setState({ 
                    eid:resdata[0].griID,
                    seldate:resdata[0].gri_date,
                    selfrom:selid     
                });   
                
                this.setState({ 
                    
                    alllstdiv4:false,               
                    adddiv:false,
                    editdiv:true,   
                  });

            });
        }

        
    }

    deleteForm(data, selfrm){
      this.data = data;
      this.selfrm = selfrm;
      this.confirmationDialog.current.openDialog();
     
    }

    deleteDataPermanent(popupResponse){
      
        if (popupResponse) {
            var stid=this.state.student;
            var selfrm=this.selfrm;
            if(selfrm==1){
                this.props.deleteRangeIronPlay(this.data, stid);
            }else if(selfrm==2){
                this.props.deleteRangeFairway(this.data, stid);
            }else if(selfrm==3){
                this.props.deleteRangeDriver(this.data, stid);
            }else if(selfrm==4){
                this.props.deleteRangeSpeciality(this.data, stid);
            }
            this.data = ""
        }
    }



render() {
      
    const { rangeironplaylist, rangefairwaylist, rangedriverlist, rangespeciallist, loading} = this.props; 
    const stdrole = localStorage.getItem('stdrole');
    const options = {
        filterType: 'dropdown',
        rowsPerPage: 50,
        rowsPerPageOptions: [50, 100, 150],
        selectableRowsHideCheckboxes: true,
    };

    const columns = [
        { name: "no", label: "NO" },
        { name: "date", label: "DATE" },
        { name: "coach", label: "COACH" },
        { name: "obsert", label: "OBSERVATION",
        options: {
            customBodyRender: (value) => {
            return <div style={{ whiteSpace: 'pre-wrap' }}>{value}</div>;
            }
        } },
        { name: "work", label: "WORK IN PROGRESS",
        options: {
            customBodyRender: (value) => {
            return <div style={{ whiteSpace: 'pre-wrap' }}>{value}</div>;
            }
        } },
        { name: "action", label: "ACTION" },
        { name: "action1", label: "ACTION1" },
      
    ];

    const tabledata1=rangeironplaylist.map((assmntval,idx) => {     
        const ebtn=<IconButton className='text-info' onClick={ ()=>this.editAssessment(assmntval.griID,1)}><EditOutlinedIcon/></IconButton>;
        const dbtn=<IconButton  className="text-danger" aria-label="Remove" onClick={ ()=>this.deleteForm(assmntval.griID,1)}  ><DeleteOutlineOutlinedIcon/></IconButton>;
   
        return {
            no:idx+1,
            date: assmntval.cdate,
            coach: assmntval.gri_coachname,
            obsert:assmntval.gri_observation,
            work:assmntval.gri_workinprocess,
            action: ebtn,
            action1:dbtn,       
        }
    });

    const tabledata2=rangefairwaylist.map((assmntval,idx) => {     
        const ebtn=<IconButton className='text-info' onClick={ ()=>this.editAssessment(assmntval.griID,2)}><EditOutlinedIcon/></IconButton>;
        const dbtn=<IconButton  className="text-danger" aria-label="Remove" onClick={ ()=>this.deleteForm(assmntval.griID,2)}  ><DeleteOutlineOutlinedIcon/></IconButton>;
   
        return {
            no:idx+1,
            date: assmntval.cdate,
            coach: assmntval.gri_coachname,
            obsert:assmntval.gri_observation,
            work:assmntval.gri_workinprocess,
            action: ebtn,
            action1:dbtn,       
        }
    });

    const tabledata3=rangedriverlist.map((assmntval,idx) => {     
        const ebtn=<IconButton className='text-info' onClick={ ()=>this.editAssessment(assmntval.griID,3)}><EditOutlinedIcon/></IconButton>;
        const dbtn=<IconButton  className="text-danger" aria-label="Remove" onClick={ ()=>this.deleteForm(assmntval.griID,3)}  ><DeleteOutlineOutlinedIcon/></IconButton>;
   
        return {
            no:idx+1,
            date: assmntval.cdate,
            coach: assmntval.gri_coachname,
            obsert:assmntval.gri_observation,
            work:assmntval.gri_workinprocess,
            action: ebtn,
            action1:dbtn,       
        }
    });

    const tabledata4=rangespeciallist.map((assmntval,idx) => {     
        const ebtn=<IconButton className='text-info' onClick={ ()=>this.editAssessment(assmntval.griID,4)}><EditOutlinedIcon/></IconButton>;
        const dbtn=<IconButton  className="text-danger" aria-label="Remove" onClick={ ()=>this.deleteForm(assmntval.griID,4)}  ><DeleteOutlineOutlinedIcon/></IconButton>;
   
        return {
            no:idx+1,
            date: assmntval.cdate,
            coach: assmntval.gri_coachname,
            obsert:assmntval.gri_observation,
            work:assmntval.gri_workinprocess,
            action: ebtn,
            action1:dbtn,       
        }
    });
      return(
            <div>
                
                {this.state.listdiv && 
                   <>
                    <div className="col-sm-12 col-md-12">
                        
                        <RctCollapsibleCard heading="IRON PLAY" chkbtn={stdrole==1? 0 :1 } addbtn onClickAdd={e => this.onAddSession(e, 1)} listbtn onClickList={e => this.onListSession(e, 1)}fullBlock>
                            <div className="table-responsive reporttable">
                                <Table hover bordered striped>
                                    <thead>
                                        <tr className="bg-primary text-white">
                                            <th>NO</th>
                                            <th>DATE</th>
                                            <th>COACH</th>
                                            <th>OBSERVATION</th>
                                            <th>WORK IN PROGRESS</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {rangeironplaylist.map((assmntval,idx) => {
                                            return (
                                                <tr>
                                                    <td>{idx+1}</td>
                                                    <td>{assmntval.cdate}</td>
                                                    <td>{assmntval.gri_coachname}</td>
                                                    <td style={{ whiteSpace: 'pre-wrap' }}>{assmntval.gri_observation}</td>
                                                    <td style={{ whiteSpace: 'pre-wrap' }}>{assmntval.gri_workinprocess}</td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </Table> 
                            </div>
                        </RctCollapsibleCard>
                    </div>
                    <div className="col-sm-12 col-md-12">
                        <RctCollapsibleCard heading="FAIRWAY WOODS" chkbtn={stdrole==1? 0 :1 } addbtn onClickAdd={e => this.onAddSession(e, 2)} listbtn onClickList={e => this.onListSession(e, 2)} fullBlock>
                            <div className="table-responsive reporttable">
                                <Table hover bordered striped>
                                    <thead>
                                        <tr className="bg-primary text-white">
                                            <th>NO</th>
                                            <th>DATE</th>
                                            <th>COACH</th>
                                            <th>OBSERVATION</th>
                                            <th>WORK IN PROGRESS</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {rangefairwaylist.map((assmntval,idx) => {
                                            return (
                                                <tr>
                                                    <td>{idx+1}</td>
                                                    <td>{assmntval.cdate}</td>
                                                    <td>{assmntval.gri_coachname}</td>
                                                    <td style={{ whiteSpace: 'pre-wrap' }}>{assmntval.gri_observation}</td>
                                                    <td style={{ whiteSpace: 'pre-wrap' }}>{assmntval.gri_workinprocess}</td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </Table> 
                            </div>
                        </RctCollapsibleCard>
                    </div>
                    <div className="col-sm-12 col-md-12">
                        <RctCollapsibleCard heading="DRIVER" chkbtn={stdrole==1? 0 :1 } addbtn onClickAdd={e => this.onAddSession(e, 3)} listbtn onClickList={e => this.onListSession(e, 3)} fullBlock>
                            <div className="table-responsive reporttable">
                                <Table hover bordered striped>
                                    <thead>
                                        <tr className="bg-primary text-white">
                                            <th>NO</th>
                                            <th>DATE</th>
                                            <th>COACH</th>
                                            <th>OBSERVATION</th>
                                            <th>WORK IN PROGRESS</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {rangedriverlist.map((assmntval,idx) => {
                                            return (
                                                <tr>
                                                    <td>{idx+1}</td>
                                                    <td>{assmntval.cdate}</td>
                                                    <td>{assmntval.gri_coachname}</td>
                                                    <td style={{ whiteSpace: 'pre-wrap' }}>{assmntval.gri_observation}</td>
                                                    <td style={{ whiteSpace: 'pre-wrap' }}>{assmntval.gri_workinprocess}</td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </Table> 
                            </div>
                        </RctCollapsibleCard>
                    </div>
                    <div className="col-sm-12 col-md-12">
                        <RctCollapsibleCard heading="SPECIALITY SHOTS" chkbtn={stdrole==1? 0 :1 } addbtn onClickAdd={e => this.onAddSession(e, 4)} listbtn onClickList={e => this.onListSession(e, 4)} fullBlock>
                            <div className="table-responsive reporttable">
                                <Table hover bordered striped>
                                    <thead>
                                        <tr className="bg-primary text-white">
                                            <th>NO</th>
                                            <th>DATE</th>
                                            <th>COACH</th>
                                            <th>OBSERVATION</th>
                                            <th>WORK IN PROGRESS</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {rangespeciallist.map((assmntval,idx) => {
                                            return (
                                                <tr>
                                                    <td>{idx+1}</td>
                                                    <td>{assmntval.cdate}</td>
                                                    <td>{assmntval.gri_coachname}</td>
                                                    <td style={{ whiteSpace: 'pre-wrap' }}>{assmntval.gri_observation}</td>
                                                    <td style={{ whiteSpace: 'pre-wrap' }}>{assmntval.gri_workinprocess}</td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </Table> 
                            </div>   
                        </RctCollapsibleCard>
                    </div>
                    </>
                } 

                {this.state.alllstdiv1 &&      
                    <div className="col-sm-12 col-md-12">
                        <RctCollapsibleCard heading="IRON PLAY" backtoadd onClick={this.onPrevSection} fullBlock>
                        <MUIDataTable
                                
                                data={tabledata1}
                                columns={columns}
                                options={options} 
                        />   
                        </RctCollapsibleCard>
                    </div>
                }    
                {this.state.alllstdiv2 && 
                    <div className="col-sm-12 col-md-12">
                        <RctCollapsibleCard heading="FAIRWAY WOODS" backtoadd onClick={this.onPrevSection} fullBlock>
                        <MUIDataTable
                               
                                data={tabledata2}
                                columns={columns}
                                options={options} 
                        />   
                        </RctCollapsibleCard>
                    </div>
                }    
                {this.state.alllstdiv3 && 
                    <div className="col-sm-12 col-md-12">
                        <RctCollapsibleCard heading="DRIVER" backtoadd onClick={this.onPrevSection} fullBlock>
                        <MUIDataTable
                                
                                data={tabledata3}
                                columns={columns}
                                options={options} 
                        />   
                        </RctCollapsibleCard>
                    </div>
                }    
                {this.state.alllstdiv4 && 
                    <div className="col-sm-12 col-md-12">
                        <RctCollapsibleCard heading="SPECIALITY SHOTS" backtoadd onClick={this.onPrevSection} fullBlock>
                        <MUIDataTable                               
                                data={tabledata4}
                                columns={columns}
                                options={options} 
                        />   
                        </RctCollapsibleCard>
                    </div>
                }  

                {this.state.adddiv && 
                  
                    <AddItem onClick={this.onPrevSection} data={this.state}/> 
                }  

                {this.state.editdiv && 

                <UpdateItems onClick={this.onBacksection} data={this.state}/>
                }

                <ConfirmationDialog
                ref={this.confirmationDialog}
                onConfirm={(res) => this.deleteDataPermanent(res)}
                data={'record'}
                />


               
            </div>

              
    )
   
}
 
}

const mapStateToProps = ({ rangelonggame}) => {
   
    const { rangeironplaylist, rangefairwaylist, rangedriverlist, rangespeciallist, loading } = rangelonggame;
	return {  rangeironplaylist, rangefairwaylist, rangedriverlist, rangespeciallist, loading };   
}


export default connect(mapStateToProps, {
    deleteRangeIronPlay,
    deleteRangeFairway,
    deleteRangeDriver,
    deleteRangeSpeciality,
    getRangeIronPlay,
    getRangeFairway,
    getRangeDriver,
    getRangeSpeciality,
    fetchRangeIronPlay,
    fetchRangeFairway,
    fetchRangeDriver,
    fetchRangeSpeciality,
    fetchPlayerIntervention
})(LongItems);
